// extracted by mini-css-extract-plugin
module.exports = {"icon":"material_icon__wNPJ0","fill":"material_fill__lmbZc","outlined":"material_outlined__7rfpo","round":"material_round__4orQI","sharp":"material_sharp__03BFu"};